export const SALES_EMAIL = "sales@qstn.us";

export const BLOCK_ID = {
  footer: "footer",
  header: "header",
};
